import clsx from 'clsx';
import React from 'react';
import { InfoIcon } from '../Icon';

import { Alert as StyledAlert, AlertContent, IconContainer } from '../AlertInactive/wrappers';

interface IAlert {
  children: React.ReactNode;
  tone?: string;
}

const AlertInactive = ({ children, tone }: IAlert, ref: React.ForwardedRef<HTMLDivElement>) => (
  <StyledAlert className={clsx(tone && `tone-${tone}`)} ref={ref}>
    {tone && (
      <IconContainer>
        <InfoIcon />
      </IconContainer>
    )}
    <AlertContent>{children}</AlertContent>
  </StyledAlert>
);

export default React.forwardRef(AlertInactive);
